var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 14H9V16H16V14Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 8H9V10H19V8Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 30C4.897 30 4 29.103 4 28V4C4 2.897 4.897 2 6 2H22C23.103 2 24 2.897 24 4V8H22V4H6V28H16V30H6Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24 22C21.794 22 20 20.206 20 18C20 15.794 21.794 14 24 14C26.206 14 28 15.794 28 18C28 20.206 26.206 22 24 22ZM26 26.84L24 25.894L22 26.84V23.65C22.627 23.873 23.298 24 24 24C24.702 24 25.373 23.873 26 23.65V26.84ZM30 18C30 14.691 27.309 12 24 12C20.691 12 18 14.691 18 18C18 19.771 18.776 21.36 20 22.459V29.999L24 28.106L28 29.999V22.459C29.224 21.36 30 19.771 30 18Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.ee3632f332a5f0b9752bfa34c579f82e.svg";
export { ForwardRef as ReactComponent };